import { Constructor } from '~/lib/ytil'
import { SVGName } from '~/ui/components/SVG'
import { BeWizrCourse } from './BeWizrCourse'
import { BeWizrLearningTrack } from './BeWizrLearningTrack'
import { BeWizrMeeting, BeWizrMeetingOccurrence } from './BeWizrMeeting'
import { BeWizrEmbedItem, BeWizrLinkItem, BeWizrMediaItem } from './BeWizrMiscItem'
import { BeWizrModel } from './BeWizrModel'

export class BeWizrLibraryTopic extends BeWizrModel {

  title!: string

  slug!: string

  itemCount!: number

  links!: {
    image: string | null
  }

  protected afterDeserialize() {
    this.id = this.slug
  }

}

export class BeWizrLibraryCategory extends BeWizrLibraryTopic {

  topic!: BeWizrLibraryTopic

  protected afterDeserialize() {
    this.id    = this.slug
    this.topic = BeWizrLibraryTopic.deserialize({
      title: this.raw.topicTitle,
      slug:  this.raw.topicSlug,
    })
  }
}

export type BeWizrLibraryItemItem =
  | BeWizrCourse
  | BeWizrLearningTrack
  | BeWizrMeeting
  | BeWizrMeetingOccurrence
  | BeWizrLinkItem
  | BeWizrEmbedItem
  | BeWizrMediaItem

export class BeWizrLibraryItem extends BeWizrModel {

  public id!: string

  public type!: BeWizrLibraryItemType

  public item!: BeWizrLibraryItemItem

  protected afterDeserialize() {
    const Model = BeWizrLibraryItemType.ModelForType(this.type)
    if (Model == null) {
      console.error(`Unknown library item type: ${this.type}`)
    } else {
      this.item = (Model as any).deserialize(this.item)
    }

    // BeWizr IDs are numeric and incremental, meaning there might be duplicate IDs
    // across models. This way, we ensure each item has a uniqe ID.
    this.id = `${this.type}_${this.item.id}`
  }
}

export type BeWizrLibraryItemType =
  | 'course'
  | 'learning_track'
  | 'meeting'
  | 'occurrence'
  | 'linkitem'
  | 'embeditem'
  | 'mediaitem'

export const BeWizrLibraryItemType: {
  all:          BeWizrLibraryItemType[]
  iconForType:  (type: BeWizrLibraryItemType) => SVGName
  ModelForType: (type: BeWizrLibraryItemType) => Constructor<BeWizrModel> | null
} = {
  all: ['course', 'learning_track', 'meeting', 'occurrence', 'embeditem', 'mediaitem', 'linkitem'],
  iconForType: (type) => {
    switch (type) {
      case 'course':
        return 'course'
      case 'learning_track':
        return 'unordered-list'
      case 'meeting':
      case 'occurrence':
        return 'meeting'
      case 'embeditem':
        return 'video'
      case 'mediaitem':
        return 'image'
      case 'linkitem':
        return 'link'
    }
  },
  ModelForType: type => {
    switch (type) {
      case 'course':
        return BeWizrCourse
      case 'learning_track':
        return BeWizrLearningTrack
      case 'meeting':
        return BeWizrMeeting
      case 'occurrence':
        return BeWizrMeetingOccurrence
      case 'embeditem':
        return BeWizrEmbedItem
      case 'mediaitem':
        return BeWizrMediaItem
      case 'linkitem':
        return BeWizrLinkItem
      default:
        return null
    }
  },
}